import {useTranslation} from 'react-i18next';

export const dateFormatter = (newValue: any) => {
	const dateObject = new Date(newValue);
	const year = dateObject.getFullYear();
	const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
	const day = dateObject.getDate().toString().padStart(2, '0');
	return `${year}-${month}-${day}`;
};
export const monthNow = () => {
	const date = new Date();
	const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

	return dateFormatter(firstDayOfMonth);
};
export function getMonthThis(): number {
	const now = new Date();
	// Метод getMonth() возвращает месяц, начиная с 0 (0 = Январь, 11 = Декабрь).
	// Поэтому мы добавляем 1, чтобы получить номер месяца в привычном формате (1-12).
	return now.getMonth() + 1;
}
export const firstDayNextMonth = (dateString?: string) => {
	const date = dateString ? new Date(dateString) : new Date();
	const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
	return dateFormatter(nextMonth);
};
export const getMonthStart = (value?: string) => {
	const date = value ? new Date(value) : new Date(); // если нет value → берем сегодня
	if (isNaN(date.getTime())) {
		throw new Error(`Invalid date: ${value}`);
	}
	date.setDate(date.getDate() - 4); // минус 4 дня
	date.setMonth(date.getMonth() - 1); // минус 1 месяц
	date.setDate(1); // первый день месяца

	return dateFormatter(date.toISOString());
};
export const todayDate = (): string => {
	// Киевское время UTC+2 (или UTC+3 в летнее время)
	const now = new Date();
	const kievTime = new Date(
		now.getTime() + now.getTimezoneOffset() * 60000 + 2 * 3600000,
	); // UTC+2
	return kievTime.toISOString().split('T')[0];
};

export const yesterdayDate = (): string => {
	// Киевское время UTC+2 (или UTC+3 в летнее время)
	const now = new Date();
	const kievTime = new Date(
		now.getTime() + now.getTimezoneOffset() * 60000 + 2 * 3600000,
	); // UTC+2
	kievTime.setDate(kievTime.getDate() - 1);
	return kievTime.toISOString().split('T')[0];
};
// Функция для получения первого числа прошлого месяца
export const getFirstDayOfLastMonth = () => {
	const now = new Date();
	const firstDayOfLastMonth = new Date(
		now.getFullYear(),
		now.getMonth() - 1,
		1,
	);
	return dateFormatter(firstDayOfLastMonth);
};
export const currentMonthName = () => {
	const {t, i18n} = useTranslation();

	const month = new Date().toLocaleString(i18n.language, {month: 'long'});
	return t(month);
};
